module.exports = __webpack_public_path__ + "static/award-99038847e471c24b46f7b3661479ad03.png";